export default __webpack_public_path__ + "static/media/revicon2.579159c5.svg";